<template>
    <div class="inner-box">
        <div class="title">방문신청약관</div>
        <div class="title-s">방문 신청 시스템에 오신 것을 환영합니다.</div>

        <ul class="progress">
            <li class="completed">
           <span>
               <span class="order">1 </span>약관동의
           </span>
                <div class="diagonal"></div>
            </li>
            <li>
           <span>
               <span class="order">2 </span>방문신청 정보입력
           </span>
                <div class="diagonal"></div>
            </li>
            <li>
           <span>
               <span class="order">3 </span>완료
           </span>
            </li>
        </ul>

        <h1>방문신청약관</h1>
        <textarea readonly>
            제1조(목적 등)
            1. 본 약관은 일진그룹(이하 "회사"라 합니다)가 방문예약 신청 홈페이지 (visit.iljin.co.kr)를 (이하 "사이트"라 합니다) 통하여 제공하는 인터넷 관련 서비스 (이하 "서비스"라 합니다)를 사용자가 이용함에 있어 사용자와 "회사"의 권리•의무 및 책임사항을 규정함을 목적으로 합니다.
            2. 본 약관에 정하는 이외의 "사용자"와 "회사"의 권리, 의무 및 책임사항에 관해서는 개인정보보호법 및 개인정보보호에 관한 제반 법령에 따릅니다.

            제2조(사용자의 정의)
            1.	"사용자"란 "사이트"에 접속하여 "회사"가 제공하는 서비스를 이용하는 자를 말하며 회원가입 없이 사이트를 이용하는 자를 말합니다.

            제3조(서비스의 제공 및 변경)
            1. "사용자"에게 아래와 같은 서비스를 제공합니다.
                ① 방문예약관련 정책
                ② 방문수속 안내
                ③ 기타 "회사"가 방문관련 "사용자"들에게 제공할 일체의 서비스
            2. 제1항의 서비스는 "사용자"에게 공지사항 등을 이용하여 제공 됩니다.
            3. "회사"는 제1항 서비스의 내용이 변경되는 경우 변경될 서비스의 내용 및 제공일자를 서비스 제공 최소 7일 전에 사이트 공지사항 등을 통해 게시후 변경된 서비스를 제공합니다.

            제4조(서비스의 중단)
            1. "회사"는 컴퓨터 등 정보통신설비의 보수점검•교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있으며, 새로운 서비스로의 교체, 기타 "회사"가 적절하다고 판단하는 사유에 의하여 현재 제공되는 서비스를 완전히 중단할 수 있습니다.
            2. 제1항에 의한 서비스 중단의 경우에는 "회사"는 공지사항 등에 게시하여 "사용자"에게 공지합니다. 다만, "회사"가 통제할 수 없는 사유로 인한 서비스의 중단(시스템 관리자의 고의, 과실이 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.

            제5조(사용자 자격 상실 등)
            1. 사용자는 회사에 방문하기 전에 자신의 개인정보의 삭제를 요청할 수 있으며 회사는 다른 법령에 당해 개인정보가 수집대상으로 명시되어 있는 등 정당한 사유가 없는 한 지체없이 방문예약 관련 사항에 대해 삭제 절차를 밟습니다. 단, 실제 방문한 이력은 회사의 정보보호를 위해 개인정보 처리방침에서 정한 기간동안 보관합니다.
            2. "사용자"가 다음 각 호의 사유에 해당하는 경우, "회사"는 출입증 발급 및 입문을 거부할 수 있습니다.
                ① 방문예약 신청 시에 허위 내용을 등록한 경우
                ② 회사의 보안정책을 위반한 경우
                ③ 서비스를 이용하여 법령과 본 약관이 금지하거나 공공의 질서와 선량한 풍속에 반하는 행위를 하는 경우
                ④ 회사가 내부 지침/규정 등에 의거 입문이 어려운 사용자라고 판단한 경우
                ⑤ 회사 내/외부 사정 등으로 인하여 사용자의 입문이 어려운 상황이 발생하는 경우
            3. 회사는 출입증 발급 및 입문을 거부하기 전 사용자에게 소명할 기회를 부여합니다.

            제6조(사용자에 대한 통지)
            1. 회사가 특정 사용자에 대한 통지를 하는 경우 사용자가 방문예약 시 제공한 휴대전화 번호로 연락할 수 있습니다.
            2. 회사가 불특정다수 이용자에 대한 통지를 하는 경우 사이트 공지사항에 공지함으로써 개별 통지에 갈음할 수 있습니다.

            제7조(이용자의 개인정보보호)
            1.	회사는 관련법령이 정하는 바에 따라서 사용자 입력정보를 포함한 사용자의 개인정보를 보호하기 위하여 노력합니다. 사용자의 개인정보보호에 관해서는 관련법령 및 회사가 정하는 개인정보처리방침에 정한 바에 의합니다.

            제8조("회사"의 의무)
            1. 회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하기 위해서 노력합니다.
            2. 회사는 사용자가 안전하게 인터넷 서비스를 이용할 수 있도록 사용자의 개인정보 보호를 위한 보안 시스템을 구축합니다.

            제9조(사용자의 개인정보에 대한 의무)
            1. 회사가 관계법령, 개인정보처리방침에 의해서 그 책임을 지는 경우를 제외하고, 자신의 개인정보에 관한 관리책임은 각 사용자에게 있습니다.
            2. 사용자는 자신의 개인정보를 제3자에게 이용하게 해서는 안됩니다.

            제10조(사용자의 의무)
            1. 사용자는 다음 각 호의 행위를 하여서는 안됩니다.
                ① 방문예약 신청시 허위내용을 등록하는 행위
                ② 회사에 게시된 정보를 변경하는 행위
                ③ 회사 기타 제3자의 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 행위
                ④ 다른 사용자의 개인정보를 도용하는 행위
                ⑤ 다른 이용자에 대한 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위
                ⑥ 회사가 제공하는 서비스에 정한 약관 기타 서비스 이용에 관한 규정을 위반하는 행위
            2. 제1항에 해당하는 행위를 한 사용자가 있을 경우 회사는 본 약관 제5조 제2항에서 정한 바에 따라 사용자의 출입증 발급 및 입문을 거부할 수 있습니다.
            3. 사용자는 그 귀책사유로 인하여 "회사"나 다른 "이용자"가 입은 손해를 배상할 책임이 있습니다.

            제11조(저작권의 귀속 및 이용제한)
            1 사이트와 관련한 자산은 저작권, 상표권, 기술에 대한 정보, 텍스트, 그래픽, 오디오, 비디오, 다운로드, 링크, 그리고 소스코드 (이하 웹사이트 서비스)이며, 회사는 서비스 대한 모든 권리를 가지고 있습니다. 모든 형태의 정보는 사용자 여러분들을 위한 것이며, 여러분들의 편의를 위해 제공되는 것입니다. 그러나, 회사는 이러한 정보에 대한 상업적 사용권을 허락하는 것은 아님을 밝혀드립니다. 사용자는 개인적인 용도가 아닌 어떠한 경우에도 이 사이트 또는 서비스를 사용할 수 없습니다.
            2 사용자는 사이트를 이용함으로써 얻은 정보를 회사의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.

            제12조(면책)
            1. 사용자가 화면에 방문예약 관련하여 입력한 내용에 관한 신뢰도 또는 정확성에 대하여는 해당 사용자가 책임을 부담하며, 회사는 내용의 부정확 또는 허위로 인해 사용자 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다.
            2. 회사는 서비스 이용과 관련하여 사용자의 고의 또는 과실로 인하여 사용자 또는 제3자에게 발생한 손해에 대하여는 아무런 책임을 부담하지 않습니다.

            제13조(약관의 개정)
            1. 회사는 약관의 규제 등에 관한 법률, 전자거래기본법, 전자서명법, 정보통신망 이용촉진 등에 관한 법률 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
            2. 회사가 본 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.
            3. 사용자는 변경된 약관에 대해 거부할 권리가 있습니다. 사용자는 변경된 약관이 공지된 후 15일 이내에 변경된 약관에 동의할 수 있고, 위 기간 내 동의하지 않거나 동의 거부의 의사표시를 한 경우 그 때부터는 서비스 이용에 제한이 있을 수 있습니다.

            제14조(재판관할)
            1. 회사와 이용자간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용하며, 본 분쟁으로 인한 소는 민사소송법상의 관할을 가지는 대한민국의 법원에 제기합니다.

            부 칙
            본약관은 2021년 1월 1부터 적용됩니다.

        </textarea>

        <div class="agreeArea">
            <input type="checkbox" id="agreeChk_1" v-model="agreeChk_1"><label for="agreeChk_1">상기내용을 확인하였으며, 방문신청 약관에 동의합니다.</label>
        </div>

        <h1>개인정보처리방침</h1>
        <textarea readonly>
           1. 개인정보의 수집 및 이용목적

            일진그룹은 수집한 개인정보를 다음의 목적을 위해 활용합니다.
            서비스 제공을 위한 본인 식별 절차에 이용
            고객 문의 및 온라인 제보 내용에 대한 진행 및 결과 알림 및 추가 확인

            2. 수집하는 개인정보 항목

            일진그룹은 이메일문의, 채용문의, 사이버감사실 온라인 제보 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
            수집항목이름, 이메일, 전화번호(휴대폰번호)수집방법홈페이지(이메일문의, 채용문의, 사이버감사실 제보하기)

            3. 개인정보의 보유 및 이용기간

            원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
            관계법령의 규정에 의하여 보존할 필요가 있는 경우 일진그룹은 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
            보존항목이름, 전화번호, 이메일보존근거신용정보의 이용 및 보호에 관한 법률보존기간3년
            ※ 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률)
        </textarea>

        <div class="agreeArea">
            <input type="checkbox" id="agreeChk_2" v-model="agreeChk_2"><label for="agreeChk_2">상기내용을 확인하였으며, 방문신청 약관에 동의합니다.</label>
        </div>

        <div class="btn">
            <button v-on:click="agree()">동의합니다</button>
            <button v-on:click="nagree()">동의하지 않습니다</button>
        </div>
    </div>

</template>

<script>

    export default {
        name: "proposal",
        data(){
            return {
                agreeChk_1:false,
                agreeChk_2:false
            }
        },
        methods: {
            agree(){
                if(this.agreeChk_1 == false || this.agreeChk_2 == false){
                    this.$swal({
                        type: 'warning',
                        text: '모든 약관에 동의하시기 바랍니다.'
                    });
                    return
                }
                this.$router.push({name: `visitRequestMg`, params:{"proposal_yn":"Y"}});
            },
            nagree(){
              this.$swal({type: 'warning', text: '약관에 동의하지 않으시면 방문신청이 불가능합니다.'}).then(() => {
              })
            }
        },
        created(){

        }
    }
</script>

<style lang="scss" scoped>
    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 13%;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
        padding:0px 0;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 0 20px;
        font-weight: bold;
    }

    .inner-box textarea{
        height:200px;
        border-top:1px solid #000;
        background-color: #fff;
        color:#989898;
        font-size: 12px;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
        font-weight: bold;
    }

    .inner-box label{
        font-size:14px;
        color:#1e88cf;
    }

    .inner-box button:first-child{
        background-color: #023e7c;
        color:#fff;
    }

    .inner-box button:last-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .inner-box .btn{
        text-align:center;
    }

    .inner-box .agreeArea{
        text-align:right;
    }

    .progress {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        height: 60px;
        margin: 0 0 1em;
        padding: 0;
    }

    .progress > li {
        width: 100% !important;
        height: 100% !important;
        border-radius: 0 !important;
        color: #fff !important;
        list-style: none;
        font-size: 13px;
        background-color: #bbb;
        position: relative;
        text-align: center;
    }

    .progress > li:last-child {
        border-right: 0;
    }

    .progress > li.completed {
        background-color: #0071bc;
        text-align: center;
    }

    .progress > li:not(.completed) {
        padding-left: 25px;
    }

    .progress > li span {
        position: relative;
        top: 17px;
    }

    .progress > li span .order {
        border: 1px solid #ababab;
        border-radius: 27px;
        width: 23px;
        height: 23px;
        background-color: #fff;
        color: #9a9898;
        margin: 0 5px 0 10px;
        font-weight: bold;
        text-align: center;
        position: relative;
        top: 1px;
        font-size: 13px;
        display:none;
    }

    .diagonal {
        width: 0;
        height: 0;
        border-top: 30px solid transparent;
        border-bottom: 30px solid transparent;
        border-left: 20px solid #bbb;
        top: 0; right: 0;
        position: absolute;
        transform: translateX(100%);
        z-index: 1;
    }
    .completed .diagonal {
        border-left-color: #0071bc;
    }

    @media (min-width: 450px) {
        .progress > li {
            font-size: 15px;
        }

        .progress > li span .order {
            width: 25px;
            height: 25px;
            line-height: 23px;
        }
    }

    @media (min-width: 700px) {
        .progress > li.completed {
            padding-left: 0px;
        }

        .progress > li {
            font-size: 18px;
        }
        .progress > li span .order {
            top: -1px;
            width: 28px;
            height: 28px;
            line-height: 25px;
            display: inline-block;
        }
    }
</style>